import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["additionalTracking", "currentTime", "displayInteractiveEducation", "enableQuizMe", "enableSummarize", "enableAdaptToIndustry", "handleDisplayInteractiveEducation", "interactiveEducationEnabled", "onFinish", "children"];
import { useEffect } from 'react';
import { VideoControls } from './VideoControls';
import { VideoPlayer, VideoPlayerProvider } from './VideoPlayer';
import { create } from 'zustand';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Global store for video playback state
 * Tracks both the current time position and actual play/finish events
 */
export const useCurrentVideoTime = create(set => ({
  currentVideoTime: 0,
  setCurrentVideoTime: time => set(() => ({
    currentVideoTime: time
  })),
  hasVideoPlayed: false,
  setHasVideoPlayed: played => set(() => ({
    hasVideoPlayed: played
  })),
  isVideoFinished: false,
  setIsVideoFinished: finished => set(() => ({
    isVideoFinished: finished
  }))
}));
export const VideoPlayerWithControls = _ref => {
  let {
      additionalTracking,
      currentTime,
      displayInteractiveEducation,
      enableQuizMe,
      enableSummarize,
      enableAdaptToIndustry,
      handleDisplayInteractiveEducation,
      interactiveEducationEnabled = false,
      onFinish,
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    setCurrentVideoTime
  } = useCurrentVideoTime();
  useEffect(() => {
    setCurrentVideoTime(currentTime || 0);
  }, [currentTime, setCurrentVideoTime]);
  return /*#__PURE__*/_jsx(VideoPlayerProvider, {
    children: /*#__PURE__*/_jsxs(VideoPlayer, Object.assign({
      onFinish: onFinish,
      onTimeUpdate: time => setCurrentVideoTime(time)
    }, props, {
      children: [/*#__PURE__*/_jsx(VideoControls, {
        additionalTracking: additionalTracking,
        displayInteractiveEducation: displayInteractiveEducation,
        enableAdaptToIndustry: enableAdaptToIndustry,
        enableQuizMe: enableQuizMe,
        enableSummarize: enableSummarize,
        handleDisplayInteractiveEducation: handleDisplayInteractiveEducation,
        interactiveEducationEnabled: interactiveEducationEnabled,
        onFinish: onFinish
      }), children]
    }))
  });
};
export default VideoPlayerWithControls;